export const environment = {
  production: true,
  eth: {
    chainId: "0x1", //hexadecimal for metamask
    chainIdInt: 1,
    chainName: "Ethereum Mainnet",
    gasFees: 0.008,
    purchaseToken: "ETH",
    presaleAddress: "0xd79096891856d344db5e8063c9a864b3e3edb32c",
    usdTAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    rpcURL: "https://polished-weathered-grass.quiknode.pro/796b7bacb55b237cdaab6d1ca484a261767d2319/",
    backupRPC: "https://polished-weathered-grass.quiknode.pro/796b7bacb55b237cdaab6d1ca484a261767d2319/",
    blockExplorerURL: "https://etherscan.io/tx/",
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [{
        chainId: "0x1",
        chainName: "Ethereum Mainnet",
        nativeCurrency: {
          name: "ETH",
          symbol: "ETH",
          decimals: 18,
        },
        rpcUrls: ["https://rpc.ankr.com/eth"],
        blockExplorerUrls: ["https://etherscan.io/"],
      }]
    }
  },
  bsc: {
    chainId: "0x38", //hexadecimal for metamask
    chainIdInt: 56,
    chainName: "BSC Mainnet",
    gasFees: 0.0025,
    purchaseToken: "BNB",
    presaleAddress: "0xd79096891856d344db5e8063c9a864b3e3edb32c",
    usdTAddress: "0x55d398326f99059ff775485246999027b3197955",
    rpcURL: "https://prettiest-young-emerald.bsc.quiknode.pro/e8517479ab1243101fefdec23ce56f4fbd7115e1/",
    backupRPC: "https://prettiest-young-emerald.bsc.quiknode.pro/e8517479ab1243101fefdec23ce56f4fbd7115e1/",
    blockExplorerURL: "https://bscscan.com/tx/",
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [{
        chainId: "0x38",
        chainName: "BSC Mainnet",
        nativeCurrency: {
          name: "BNB",
          symbol: "BNB",
          decimals: 18,
        },
        rpcUrls: ["https://bsc-dataseed2.ninicoin.io/"],
        blockExplorerUrls: ["https://bscscan.com/"],
      }]
    }
  },
  minToken: 100,
  tokenAddress: "0xe4ab0be415e277d82c38625b72bd7dea232c2e7d",
  tokenName: "XRP20",
  iidDashFx: 1093,
  urlDashFx: 'https://mx2wfcwc6rhlbx2dih7ico7o240rahng.lambda-url.eu-west-2.on.aws/',
  referUrl: 'https://mjdtnqxknhhrwhpj3ntlqkrlfa0eilfq.lambda-url.eu-west-2.on.aws/',
  walletConnectId: '2ed0dd82dae60cd1111bef41143b273a',
  stakingAddress: '0x4b6755b90faf61dbeed58c6fd0e7f22b5ef56b7c',
  apyCalcConst: '10000000000'
};
